import React from 'react'
import Tour from '../_atoms/Tour'
import { locale, styles } from './tourSettings'

const CustomTour = (props) => {
  return (
    <>
      <Tour {...props} locale={locale} styles={styles} />
    </>
  )
}

export default CustomTour
